import { motion } from "framer-motion";

const STYLES = {
  selected: "border-[var(--forest)] bg-[var(--lime)] text-[var(--ink)]",
  taken: "cursor-not-allowed border-black/10 bg-black/10 text-black/35",
  confirmado: "border-[var(--forest)] bg-[var(--forest)] text-white",
  reservado: "border-amber-500 bg-amber-100 text-amber-900",
  bloqueado: "border-black/30 bg-black/70 text-white",
  off: "cursor-not-allowed border-black/5 bg-black/[0.03] text-black/25",
  free: "border-[var(--forest)]/40 bg-white text-[var(--forest)] [@media(hover:hover)]:hover:bg-[var(--forest)] [@media(hover:hover)]:hover:text-white",
};
const ICON = { stairs: "≡", wc: "WC", driver: "◎" };

export const SeatGrid = ({ decks = [], stateOf, onSeat, testPrefix = "seat" }) => (
  <div className="grid gap-4 sm:grid-cols-2">
    {decks.map((d) => (
      <div key={d.name} className="min-w-0 overflow-x-auto rounded-[22px] border border-black/10 bg-[var(--paper)] p-4">
        <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--muted-ink)]">{d.name}</p>
        <div className="mb-3 h-2 rounded-full bg-[var(--ink)]/80" title="Frente" />
        <div className="mx-auto grid w-max gap-2" style={{ gridTemplateColumns: `repeat(${d.cols}, 2.5rem)` }}>
          {Array.from({ length: d.rows * d.cols }, (_, i) => {
            const r = Math.floor(i / d.cols), c = i % d.cols;
            const cell = (d.cells ?? []).find((x) => x.r === r && x.c === c);
            if (!cell) return <span key={i} className="h-10 w-10" />;
            if (cell.kind !== "seat") return <span key={i} className="grid h-10 w-10 place-items-center rounded-md bg-black/5 text-[10px] font-bold text-black/40">{ICON[cell.kind]}</span>;
            const st = stateOf(cell.number, cell);
            const disabled = ["taken", "off"].includes(st) || !onSeat;
            return (
              <motion.button key={i} type="button" whileTap={{ scale: 0.85 }} disabled={disabled && st !== "bloqueado" && st !== "confirmado" && st !== "reservado"}
                onClick={() => onSeat?.(cell.number, cell)} data-testid={`${testPrefix}-${cell.number}`} title={cell.category} aria-pressed={st === "selected"}
                className={`grid h-10 w-10 place-items-center rounded-t-xl rounded-b-md border-2 font-mono text-[11px] font-semibold transition-colors duration-200 ${STYLES[st] ?? STYLES.free}`}>
                {cell.number}
              </motion.button>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);
